module.exports = __webpack_public_path__ + "static/sport/bgi-btn-reg.30e3bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bgi-btn-reg.png
// module id = yLrB
// module chunks = 0